import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor, PEDIDOS_ORCAMENTO_EXTENSION } from "../../services/api.service";
import TableView from "../Common/TableView";
import { PedidosOrcamentoConfig } from "./PedidosOrcamentoConfig";

export default function PedidosOrcamento() {
	return (
		<>
			<TableView
				title={"Pedidos de Orçamento"}
				getEntity={paginatedGetWithProcessor(PEDIDOS_ORCAMENTO_EXTENSION, generalObjectBuilder(PedidosOrcamentoConfig))}
				postEntity={genericPost(PEDIDOS_ORCAMENTO_EXTENSION)}
				editEntity={genericUpdate(PEDIDOS_ORCAMENTO_EXTENSION)}
				deleteEntity={genericDelete(PEDIDOS_ORCAMENTO_EXTENSION)}
				tableConfigs={PedidosOrcamentoConfig}
				entityName={"Pedido de Orçamento"}
				dataBuildFunction={generalObjectBuilder(PedidosOrcamentoConfig)}
				idProp={"id"}
				reroute={true}
			/>
		</>
	);
}
